/**
 * Environment detection utilities
 */

/**
 * Detects if the application is running in Storybook
 * @returns true if running in Storybook environment
 */
export const isStorybook = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  // Check multiple indicators for Storybook environment
  return !!(
    // Check if running on Storybook's default port
    (window.location.hostname === 'localhost' && window.location.port === '6006') ||
    // Check for Storybook-specific global variables
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__STORYBOOK_CLIENT_API__ ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__STORYBOOK_PREVIEW__ ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__STORYBOOK_ADDON_CHANNEL__ ||
    // Check for our custom flag (will be set in preview.ts)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).__IS_STORYBOOK__
  );
};

/**
 * Detects if the application is running in development mode
 * @returns true if running in development environment
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * Detects if the application is running in test mode
 * @returns true if running in test environment
 */
export const isTest = (): boolean => {
  return process.env.NODE_ENV === 'test';
};